<!-- eslint-disable vue/no-v-for-template-key -->
<script setup lang="ts">
const props = defineProps<{
  value: string,
  userId?: string | string[]
}>()

const { data } = await useFetch<{ user: SerializedUserSchema }>(`/api/user/${props.userId}`, { key: `user_${props.userId}` })

const definitionListProps: { label: string, value: string }[] = []
if (data.value?.user.country && data.value.user.country !== '-') {
  definitionListProps.push({
    label: '国',
    value: countryPropsList.find(countryProps => countryProps.value === data.value?.user.country)?.label || ''
  })
}
if (data.value?.user.city) {
  definitionListProps.push({
    label: '市',
    value: data.value.user.city
  })
}
if (data.value?.user.rank && data.value.user.rank !== '-') {
  definitionListProps.push({
    label: '段級',
    value: danKyuPropsList.find(danKyuProps => danKyuProps.value === data.value?.user.rank)?.label || ''
  })
}
if (data.value?.user.birthday) {
  definitionListProps.push({
    label: '誕生日',
    value: data.value.user.birthday
  })
}
</script>
<template>
  <v-window-item :value="value" class="window-item-user-profile">
    <v-row
      class="mb-6"
      no-gutters
    >
      <v-col xs="12" sm="6" md="6">
        <div v-if="data?.user.selfIntroduction" class="pa-4">
          <h3 class="mt-4 mb-4 text-subtitle-1">
            自己紹介
          </h3>
          <p class="text-body-2 border-sm pa-4 rounded">
            {{ data?.user.selfIntroduction }}
          </p>
        </div>
        <div v-if="definitionListProps.length > 0" class="pa-4">
          <h3 class="mt-4 mb-4 text-subtitle-1">
            詳細
          </h3>
          <dl class="d-flex flex-wrap border-b-sm">
            <template
              v-for="(item, index) in definitionListProps"
              :key="index"
            >
              <dt
                class="text-body-2 border-t-sm w-50 pa-4"
              >
                {{ item.label }}
              </dt>
              <dd
                class="text-body-2 border-t-sm w-50 pa-4"
              >
                {{ item.value }}
              </dd>
            </template>
          </dl>
        </div>
        <div v-if="data?.user.webpage" class="pa-4">
          <h3 class="mt-4 mb-4 text-subtitle-1">
            ウェブサイト
          </h3>
          <a :href="data.user.webpage" class="text-body-2">{{ data.user.webpage }}</a>
        </div>
      </v-col>
    </v-row>
  </v-window-item>
</template>

<style scoped lang="scss">
.window-item-user-home {
  overflow: hidden;
}
</style>
